export default "__VITE_ASSET__CGCaXjAN__"